export const AboutMe = {
  name: "Pawel Owiesek",
  content:
    " 👨🏻‍💻💻 I’m a passionate Frontend Developer in love with React,currently looking for new job opportunities.",
  email: "PawelOwiesek@gmail.com",
  github: "https://github.com/PawelOwiesek",
  linkedIn: "www.linkedin.com/in/pawel-owiesek-9b5687244",
};

export const skills = [
  "Semantic & accessible HTML",
  "Responsive Web Design",
  "Teamwork",
  "Markdown",
  "Immutability",
  "CSS BEM convention",
  "JavaScript ES6+",
  "CSS Grid",
  "CSS Flexbox",
  "Git",
  "React",
  "React Hooks",
  "React Router",
  "Redux (Toolkit)",
  "Redux-Saga",
  "Error handling",
  "Working with API (fetch, axios)",
  "Promises, Async/Await",
  "GitHub Pull Requests & Review",
  "Trello",
  "Scrum",
  "NPM",
];

export const skillsToLearn = [
  "TypeScript",
  "Node.js",
  "React Context",
  "Cypress",
  "Unit testing",
  "JS classes",
  "React Native",
];
